import React from 'react';
import classes from './PackagePendingCard.module.css';
import CommonCard from '../CommonCard';
import { CurrencyIcon } from '../../../Assets/icons';
const PackagePendingCard = ({ onCancelRequest, data }) => {
  return (
    <CommonCard>
      <ul className={classes.wrapper}>
        <li>
          <CommonCard className={classes.frame}>
            <CurrencyIcon size={30} color="var(--primary-color)" />
          </CommonCard>
        </li>
        <li>
          <div className={classes.topHeaderInfo}>
            <h3 className={classes.heading}>Payment Pending</h3>
            <p className={classes.name}>{data?.subscriptionNote}</p>
          </div>
          <p className={classes.description}>
            System verification may take up to 24 hours to process. For queries and issues raise a
            ticket
          </p>
        </li>
      </ul>
      <span
        className={classes.navigateAction}
        onClick={() => {
          if (typeof onCancelRequest === 'function') {
            onCancelRequest(data);
          }
        }}>
        Cancel Request
      </span>
    </CommonCard>
  );
};

export default PackagePendingCard;
